import { formatShortMonthDay } from "@clipboard-health/date-time";
import { DotSeparatedList, Text } from "@src/appV2/redesign/system/ui-components";

import { formatToHoursAndMinutes } from "../../../utils/formatToHoursAndMinutes";
import { type PaymentsItemShift } from "../api/useGetWorkerPayments";
import { type PaymentsListItem } from "../types/PaymentsListItem";

export interface PaymentsListItemDescriptionProps {
  item: PaymentsListItem;
}

export function PaymentsListItemDescription(props: PaymentsListItemDescriptionProps) {
  return (
    <Text
      inline
      variant="body2"
      sx={(theme) => ({ color: theme.palette.text.secondary, textAlign: "left" })}
    >
      <DotSeparatedList>{getDescriptionTexts(props.item)}</DotSeparatedList>
    </Text>
  );
}

function getShiftDurationInMinutes(shift: PaymentsItemShift): number {
  return Math.floor(shift.attributes.time * 60);
}

// the resulting string[] is rendered in a DotSeparatedList
function getDescriptionTexts(item: PaymentsListItem): string[] {
  switch (item.attributes.paymentCategory) {
    case "shift-verification": {
      const texts: string[] = [];

      if (item.shift) {
        texts.push(
          `Worked shift on ${formatShortMonthDay(item.shift.attributes.start)}`,
          `${item.shift.attributes.slot.toUpperCase()}`
        );

        const shiftDurationInMinutes = getShiftDurationInMinutes(item.shift);

        if (shiftDurationInMinutes) {
          texts.push(
            `${formatToHoursAndMinutes(
              // formatToHoursAndMinutes wants its argument in seconds -> we multiply by 60
              shiftDurationInMinutes * 60
            )}`
          );
        }
      }

      return texts;
    }

    case "shift-sent-home": {
      return ["Sent home"];
    }

    case "worked-break": {
      return ["Worked break"];
    }

    case "shift-cancellation": {
      return ["Shift cancelled by workplace"];
    }

    case "shift-adjustment": {
      return ["Shift adjustment"];
    }

    case "etp-bonus":
    case "manual-bonus": {
      if (item.attributes.description?.length > 0) {
        return [item.attributes.description];
      }

      return item.workplace ? ["Bonus"] : [];
    }

    case "other": {
      return [];
    }

    default: {
      return item.attributes.paymentCategory satisfies never;
    }
  }
}
